import React from "react";
import Layout from "../../components/Layout";
import HeroSection from "../../components/HeroSection/HeroSection";
import { useTranslation } from "react-i18next";
import ReusableSlider from "../../components/ReusableSlider/ReusableSlider";
import { Helmet } from "react-helmet-async";

/*----- Hero Images -----*/
import heroImage1 from "../../assets/images/small-hall/smallHall8.jpg";
import heroImage2 from "../../assets/images/small-hall/smallHall9.jpg";
import heroImage3 from "../../assets/images/small-hall/smallHall10.jpg";
import heroImage4 from "../../assets/images/small-hall/smallHall11.jpg";
import heroImage5 from "../../assets/images/small-hall/smallHall12.jpg";

/*----- Gallery Images -----*/
import galleryImage1 from "../../assets/images/small-hall/smallHall13.jpg";
import galleryImage2 from "../../assets/images/small-hall/smallHall14.jpg";
import galleryImage3 from "../../assets/images/small-hall/smallHall15.jpg";
import galleryImage4 from "../../assets/images/small-hall/smallHall16.jpg";
import galleryImage5 from "../../assets/images/small-hall/smallHall17.jpg";
import galleryImage6 from "../../assets/images/small-hall/smallHall18.jpg";
import galleryImage7 from "../../assets/images/small-hall/smallHall19.jpg";
import galleryImage8 from "../../assets/images/small-hall/smallHall20.jpg";

const GreatHallGallery = [
  galleryImage1,
  galleryImage2,
  galleryImage3,
  galleryImage4,
  galleryImage5,
  galleryImage6,
  galleryImage7,
  galleryImage8,
];

export default function SmallHall() {
  const { t } = useTranslation(["small_hall", "links"]);
  return (
    <Layout>
      <Helmet>
        <title>Mala sala</title>
        <meta
          name="description"
          content={
            "Dekoracija ove sale obično je sofisticirana i profinjena. Može se prilagoditi prema temi ili stilu vašeg događaja. Zidovi mogu biti ukrašeni elegantnim tapetama ili diskretnim umetničkim delima, dodajući dozu elegancije. Rasveta je pažljivo osmišljena kako bi stvorila ugodnu atmosferu, a diskretni lusteri stvaraju toplu i romantičnu atmosferu"
          }
        />
        <link rel="canonical" href={"https://vidovdanrestoran.rs/small-hall"} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={"Mala sala"} />
        <meta
          property="og:description"
          content={
            "Dekoracija ove sale obično je sofisticirana i profinjena. Može se prilagoditi prema temi ili stilu vašeg događaja. Zidovi mogu biti ukrašeni elegantnim tapetama ili diskretnim umetničkim delima, dodajući dozu elegancije. Rasveta je pažljivo osmišljena kako bi stvorila ugodnu atmosferu, a diskretni lusteri stvaraju toplu i romantičnu atmosferu"
          }
        />
        <meta property="og:image" content={heroImage1} />
        <meta
          property="og:url"
          content={"https://vidovdanrestoran.rs/small-hall"}
        />
        <meta property="og:site_name" content="Vidovdan" />
        <meta property="og:locale" content="sr_RS" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={"Mala sala"} />
        <meta
          name="twitter:description"
          content={
            "Dekoracija ove sale obično je sofisticirana i profinjena. Može se prilagoditi prema temi ili stilu vašeg događaja. Zidovi mogu biti ukrašeni elegantnim tapetama ili diskretnim umetničkim delima, dodajući dozu elegancije. Rasveta je pažljivo osmišljena kako bi stvorila ugodnu atmosferu, a diskretni lusteri stvaraju toplu i romantičnu atmosferu"
          }
        />
        <meta name="twitter:image" content={heroImage1} />
      </Helmet>
      <HeroSection
        images={[heroImage1, heroImage2, heroImage3, heroImage4, heroImage5]}
        title={t("small_hall_hero_title")}
        subTitle={t("small_hall_hero_subtitle")}
        description={t("small_hall_hero_description")}
      />
      <ReusableSlider
        slides={GreatHallGallery}
        title={t("small_hall_title")}
        description={t("small_hall_description")}
      />
    </Layout>
  );
}
